import { z } from 'zod';

// Ports app/[brand]/admin/curriculums/_components/actions.schema.ts. The Next
// version had separate add/update schemas that transformed string form fields;
// here the forms are controlled React state, so a single per-locale name schema
// covers both add and edit and the numeric ids stay numbers in the caller.
export const curriculumNamesSchema = z.object({
  en: z.string().min(1),
  sv: z.string(),
  no: z.string(),
  dk: z.string(),
  de: z.string(),
  fr: z.string(),
  fi: z.string(),
  pt: z.string(),
  pl: z.string(),
});

export type CurriculumNames = z.infer<typeof curriculumNamesSchema>;
